module.exports = __webpack_public_path__ + "static/media/icons-yc-qrcode-hover.1060cf1a.svg";